import { useState } from 'react'
import {
  HiOutlineExternalLink,
  HiOutlineInformationCircle,
  HiOutlineX,
} from 'react-icons/hi'
import useDocumentTitle from '../../hooks/useDocumentTitle'
import supabaseGuide from './supabaseGuide'

const guides = [supabaseGuide]

const imageUrl = (src) => `${process.env.PUBLIC_URL}${src}`

export default function GuidesPage() {
  useDocumentTitle('Integration Guides')

  const [activeId, setActiveId] = useState(guides[0].id)
  const [lightbox, setLightbox] = useState(null)
  const guide = guides.find((item) => item.id === activeId)

  return (
    <div className="guide-page">
      <div className="page-header">
        <div>
          <h1>Integration Guides</h1>
          <p>How to check the third-party services connected to Kleezy</p>
        </div>
      </div>

      <div className="guide-tabs" role="tablist">
        {guides.map((item) => (
          <button
            key={item.id}
            type="button"
            role="tab"
            aria-selected={item.id === activeId}
            className={`guide-tab ${item.id === activeId ? 'active' : ''}`}
            onClick={() => setActiveId(item.id)}
          >
            {item.label}
          </button>
        ))}
      </div>

      <div className="guide-card">
        <div className="guide-intro-header">
          <div>
            <h3>What is it for?</h3>
            <p>{guide.subtitle}</p>
          </div>
          <a
            href={guide.dashboardUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary"
          >
            <HiOutlineExternalLink />
            {guide.dashboardLabel}
          </a>
        </div>
        <p>{guide.role}</p>
        <ul className="guide-list">
          {guide.usedFor.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </div>

      {guide.sections.map((section) => (
        <div className="guide-card" key={section.title}>
          <div className="guide-card-title">
            <div className="guide-card-icon">
              <section.icon />
            </div>
            <h3>{section.title}</h3>
          </div>
          <p>{section.intro}</p>
          <ol className="guide-steps">
            {section.steps.map((step) => (
              <li key={step}>{step}</li>
            ))}
          </ol>
          {section.note && (
            <div className="guide-note">
              <HiOutlineInformationCircle />
              <span>{section.note}</span>
            </div>
          )}
          {section.images?.length > 0 && (
            <div className="guide-images">
              {section.images.map((image) => (
                <figure className="guide-figure" key={image.src}>
                  <button
                    type="button"
                    className="guide-figure-button"
                    onClick={() => setLightbox(image)}
                    title="Click to enlarge"
                  >
                    <img src={imageUrl(image.src)} alt={image.alt} loading="lazy" />
                  </button>
                  <figcaption>{image.caption}</figcaption>
                </figure>
              ))}
            </div>
          )}
        </div>
      ))}

      <div className="guide-card">
        <h3>Good to know</h3>
        <ul className="guide-list">
          {guide.goodToKnow.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </div>

      {lightbox && (
        <div className="guide-lightbox" onClick={() => setLightbox(null)}>
          <button
            type="button"
            className="guide-lightbox-close"
            onClick={() => setLightbox(null)}
            title="Close"
          >
            <HiOutlineX />
          </button>
          <img
            src={imageUrl(lightbox.src)}
            alt={lightbox.alt}
            onClick={(e) => e.stopPropagation()}
          />
          <p>{lightbox.caption}</p>
        </div>
      )}
    </div>
  )
}
